import { render, staticRenderFns } from "./MovementWithoutPremium.vue?vue&type=template&id=41288a73&scoped=true&"
import script from "./MovementWithoutPremium.vue?vue&type=script&lang=js&"
export * from "./MovementWithoutPremium.vue?vue&type=script&lang=js&"
import style0 from "./MovementWithoutPremium.vue?vue&type=style&index=0&id=41288a73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41288a73",
  null
  
)

export default component.exports